import { Immutable } from "immer";
import React from "react";

import type { HeroBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

type Props = Immutable<{
    value: Value;
}>;

export const HeroBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    // Mirror the legacy template's `{% if value.background_style.style %}`
    // fallback to `background--ash`.
    const bgClass = v.background_style?.style || "background--ash";
    const image = v.image;
    // The legacy template rendered `{% image value.image fill-1800x700 %}`.
    // The block now serializes that exact fill spec, so read its rendition
    // URL directly (`image.url` is the uncropped original, wrong aspect).
    const imageUrl = image?.renditions["fill-1800x700"]?.url;
    // Wagtail's `{% image %}` `.alt` resolves to the image's default alt text.
    const imageAlt = image?.default_alt_text ?? "";
    return (
        <section className={concatClassNames(["hero", "hero--block", bgClass])}>
            <img alt={imageAlt} src={imageUrl} />
            {/* Render RichTextBlock directly (no wrapper, no className): its
                own <div> is the legacy template's single content <div> that
                the `.hero > div` SCSS targets. */}
            <RichTextBlock value={v.rich_text ?? ""} />
        </section>
    );
};
